import { atom } from "recoil";

export const CountNotificationState = atom({
  key: "CountNotificationState",
  default: 0,
});
